import { useCurrentModule } from '../components';
import { PERSONALIZED_CONTENT_QUERY_OPTIONS, useIsPersonalizedContentEnabled, usePersonalizedParams } from './usePersonalizedParams';
import { useReportQueryError } from './useReportQueryError';
export const usePersonalizedTitle = () => {
  const module = useCurrentModule();
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    params,
    enabled
  } = usePersonalizedParams();
  const reportQueryError = useReportQueryError();
  const {
    data,
    isLoading
  } = module.SDK.personalizedTitleApiClient.hooks.useGetPersonalizedTitle(params, enabled, {
    ...PERSONALIZED_CONTENT_QUERY_OPTIONS,
    onError: error => reportQueryError('getPersonalizedTitle', error)
  });
  return {
    translation: isEnabled ? data == null ? void 0 : data.translation : undefined,
    isLoading: enabled && isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedTitle.js.map